import React from 'react'
import { ReCaptcha } from 'react-recaptcha-v3'
import { postRecaptcha } from '../../utilities'

export default function withRecaptcha(WrappedComponent) {
  /* eslint-disable-next-line */
  return class extends React.Component {
    constructor(props) {
      super(props)
      this.state = {
        recaptchaScore: 0.5
      }
    }

    verifyCallback = recaptchaToken => {
      postRecaptcha({ 'g-recaptcha-response': recaptchaToken }).then(resp => {
        this.setState({ recaptchaScore: resp.score })
      })
    }

    render() {
      return (
        <React.Fragment>
          <ReCaptcha
            sitekey="6LdDlnoUAAAAAEwiLpwIZTK_DgZkRHkfGu3G3oTc"
            action="action_name"
            verifyCallback={this.verifyCallback}
          />
          <WrappedComponent
            recaptchaScore={this.state.recaptchaScore}
            {...this.props}
          />
        </React.Fragment>
      )
    }
  }
}
